import { render, staticRenderFns } from "./SectionCard.vue?vue&type=template&id=c95231ba&scoped=true&"
import script from "./SectionCard.vue?vue&type=script&lang=js&"
export * from "./SectionCard.vue?vue&type=script&lang=js&"
import style0 from "./SectionCard.vue?vue&type=style&index=0&id=c95231ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95231ba",
  null
  
)

export default component.exports